import {create} from 'zustand';

interface ContractDocumentAddModalState {
  open: boolean;

  documentAddModalOpen: () => void;
  documentAddModalClose: () => void;
}

export const useContractDocumentAddModalStore = create<ContractDocumentAddModalState>((set) => ({
  open: false,

  documentAddModalOpen: () => set({open: true}),
  documentAddModalClose: () => set({open: false}),
}));

export const {documentAddModalClose, documentAddModalOpen} = useContractDocumentAddModalStore.getState();
